import AsSeenInLogos from './as-seen-in-logos.json';
import TrustedbyLogos from './trusted-by-logos.json';

type LogoData = {
  title: string;
  url: string | null;
  imgTitle: string;
  imgUrl: string;
};

const Logo = ({ logo }: { logo: LogoData }) => {
  return (
    <a className='min-w-48' href={logo.url ?? ''} target='_blank' rel='noopener noreferrer'>
      <img
        // Note that the padding actually makes these 128x128. Strange, but this matches the legacy home page implementation
        className='transition-all grayscale hover:grayscale-0 p-4'
        src={`https://optimole.movingworlds.org/h:160/w:160/q:85/${logo.imgUrl}`}
        alt={logo.imgTitle}
        title={logo.imgTitle}
        width={160}
        height={160}
      />
    </a>
  );
};

export const AsSeenIn = () => {
  return (
    <>
      {AsSeenInLogos.map((logo: LogoData, index: number) => (
        <Logo key={index} logo={logo} />
      ))}
    </>
  );
};

export const TrustedBy = () => {
  return (
    <>
      {TrustedbyLogos.map((logo: LogoData, index: number) => (
        <Logo key={index} logo={logo} />
      ))}
    </>
  );
};
